/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import Drawer from "@mui/material/Drawer";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
// import Button from '@mui/material/Button';

import UserListSaveDialog from "../../components/userlist/save/UserListSaveDialog";
import UserListLoadDialog from "../../components/userlist/load/UserListLoadDialog";
import ResultList from "../../components/result/ResultList";
import SidebarView from "./sidebar/SidebarView";
import LoadingContainer from "../../components/loading/LoadingContainer";
import Backend from "../../services/Backend";
import BaseComponent from "../../base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import "./App.css";
import logoSE from "../../images/logo_se.png";
import logoDK from "../../images/logo_dk.png";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import ErrorView from "containers/error/Error";

const maxSelectedProducts = 20;

class App extends BaseComponent {
  state = {};
  faChartLine = faChartLine;
  isThirdPartyCookiesEnabled = true;

  constructor(props) {
    super(props);

    this.state = {
      // Sidebar data
      manufacturer: "",
      categoryId: null,
      searchText: "",
      activePrices: true,
      // Search
      searchResult: [],
      searchPage: 1,
      searchLoading: false,
      searchSequence: 0,

      // Other
      selectedProducts: [],
      welcomeText: true,
      loading: true,
      snackbar: "",
    };

    this.restoreSelectedProducts()
      .then((products) => {
        this.updateSelectedProducts(products);
      })
      .catch((e) => {
        this.updateSelectedProducts([]);
        console.info(e);
      });
  }

  searchProductsByTreeCategory(page, onscroll = false) {
    if (page && page > this.state.searchPage + 1) {
      return;
    }
    if (!this.state.categoryId) {
      return;
    }
    const newSequence = this.state.searchSequence + 1;
    this.setState(
      {
        searchResult: onscroll ? this.state.searchResult : [],
        searchLoading: true,
        searchSequence: newSequence,
      },
      () => {
        Backend.fetchSearchResultsByTreeCategory(this.state.categoryId, page)
          .then((result) => {
            if (this.state.searchSequence != newSequence) {
              return;
            }
            const searchResult = [...this.state.searchResult, ...result];
            this.setState({
              searchResult,
              searchLoading: false,
              searchSequence: newSequence,
            });
          })
          .catch((err) => {
            console.error(err);
          });
      },
    );
  }

  searchProducts(page, onscroll = false) {
    if (page && page > this.state.searchPage + 1) {
      return;
    }

    if (!this.state.searchText && !this.state.categoryId && !this.state.manufacturer) {
      this.setState({
        searchResult: [],
      });
      return;
    }
    const newSequence = this.state.searchSequence + 1;
    this.setState(
      {
        searchResult: onscroll ? this.state.searchResult : [],
        searchLoading: true,
        searchSequence: newSequence,
      },
      () => {
        Backend.fetchSearchResults(this.state.searchText, this.state.manufacturer, this.state.categoryId, page || this.state.searchPage, this.state.activePrices)
          .then((result) => {
            if (this.state.searchSequence !== newSequence) {
              return;
            }
            const searchResult = [...this.state.searchResult, ...result];
            this.setState({
              searchLoading: false,
              searchResult,
              searchPage: page && result.length > 0 ? page : this.state.searchPage,
            });
          })
          .catch((err) => {
            console.error(err);
          });
      },
    );
  }

  handleScrollToBottom() {
    if (this.state.searchLoading) {
      return;
    }
    const page = this.state.searchPage + 1;
    const hasCategoryOnly = this.state.categoryId && !this.state.searchText && !this.state.manufacturer;
    if (hasCategoryOnly) {
      this.searchProductsByTreeCategory(page, true);
      this.setState({ searchPage: page });
    } else {
      this.searchProducts(page, true);
      this.setState({ searchPage: page });
    }
  }

  setActivePrices(activePrices) {
    this.setState({ activePrices });
  }

  setManufacturer(manufacturer) {
    this.setState({
      manufacturer,
      searchPage: 1,
      welcomeText: false,
    });
  }

  setSearchText(searchText) {
    this.setState({
      searchText,
      searchPage: 1,
      welcomeText: false,
    });
  }

  setCategory(categoryId) {
    if (this.state.categoryId !== categoryId) {
      this.setState({
        categoryId,
        welcomeText: false,
      });
    }
  }

  setTreeCategory(category) {
    if (category === null || category === undefined) {
      this.setState({
        categoryId: null,
        searchResult: [],
        searchPage: 1,
        welcomeText: false,
      });
      return;
    }
    if (this.state.categoryId !== category && !this.state.searchText && !this.state.manufacturer) {
      this.setState(
        {
          categoryId: category,
          searchResult: [],
          searchPage: this.state.searchPage || 1,
          welcomeText: false,
        },
        () => {
          this.searchProductsByTreeCategory(this.state.searchPage || 1);
        },
      );
    } else {
      this.setState({
        categoryId: category,
        searchResult: [],
        searchPage: this.state.searchPage || 1,
        welcomeText: false,
      });
      this.searchProducts(1);
    }
  }

  updateSelectedProducts(selectedProducts) {
    this.setSelectedProducts(selectedProducts);
    this.setState({
      selectedProducts,
      loading: false,
    });
  }

  addToSelectedProducts(product) {
    const selected = this.state.selectedProducts;
    if (selected.length >= maxSelectedProducts) {
      this.setState({
        snackbar: this.props.intl.formatMessage({ id: "errors.maxProductsReached" }),
      });
      return;
    }

    const i = selected.indexOf(product);
    if (i === -1) {
      selected.push(product);
      this.updateSelectedProducts(selected);
    }
  }

  removeFromSelectedProducts(product) {
    const selected = this.state.selectedProducts;
    this.updateSelectedProducts(selected.filter((elem) => elem.id !== product.id));
  }

  goToDetails() {
    this.redirect("/details");
  }

  onUserListLoaded(products) {
    this.updateSelectedProducts(products);
  }

  onResetClicked() {
    this.updateSelectedProducts([]);
  }

  resetSearchFilters() {
    this.setState((prevState) => ({
      manufacturer: "",
      searchText: "",
      categoryId: null,
      searchResult: [],
      searchPage: 1,
      welcomeText: false,
      resetTreeTrigger: (prevState.resetTreeTrigger || 0) + 1,
    }));
  }

  handleSearchClicked() {
    const searchText = this.state.searchText;
    const manufacturer = this.state.manufacturer;
    const categoryId = this.state.categoryId;

    if (!searchText && !manufacturer && categoryId) {
      this.searchProductsByTreeCategory(this.state.searchPage || 1);
    } else {
      this.searchProducts(1, searchText, manufacturer, categoryId);
    }
    this.setState({
      searchResult: [],
    });
  }

  renderSidenav() {
    return (
      <SidebarView
        onManufacturerChanged={this.setManufacturer.bind(this)}
        onSearchTextChanged={this.setSearchText.bind(this)}
        onCategoryChanged={this.setTreeCategory.bind(this)}
        onResetClicked={this.onResetClicked.bind(this)}
        onResetSearchFilters={this.resetSearchFilters.bind(this)}
        onSearchClicked={this.handleSearchClicked.bind(this)}
        onActivePricesChanged={this.setActivePrices.bind(this)}
        categoryId={this.state.categoryId}
        searchText={this.state.searchText}
        manufacturer={this.state.manufacturer}
        resetTreeTrigger={this.state.resetTreeTrigger}
        selectedProducts={this.state.selectedProducts}
      />
    );
  }

  renderContent() {
    const selectedProducts = this.state.selectedProducts;

    const clearDisabled = selectedProducts.length === 0;

    if (this.state.loading) {
      return <LoadingContainer className="loadingContent" enabled />;
    }

    if (this.state.welcomeText && !selectedProducts.length) {
      return (
        <div className="alignCenter">
          <div className="welcomeText">
            <img src={this.props.intl.locale === "dk" ? logoDK : logoSE} style={{ width: "400px" }} />
            <h2>
              <FormattedMessage id="welcome.title" />
            </h2>
            <FormattedMessage id="welcome.instructions" />
            <br />
            <FormattedMessage id="welcome.features" />
          </div>
        </div>
      );
    }

    return (
      <div className="productList">
        {(true || selectedProducts.length > 0) && (
          <ResultList className="selected" products={selectedProducts} selectedProducts={selectedProducts} noResult={this.props.intl.formatMessage({ id: "welcome.noSelection" })} onAddProduct={this.addToSelectedProducts.bind(this)} onRemoveProduct={this.removeFromSelectedProducts.bind(this)}>
            <nav>
              <div className="detailsButton">
                {
                  <Button variant="contained" onClick={this.goToDetails.bind(this)} disabled={this.state.selectedProducts.length === 0}>
                    <FontAwesomeIcon icon={faChartLine} style={{ color: "#FFF", marginRight: "5px" }} /> <FormattedMessage id="navigation.showDetails" />
                  </Button>
                }
              </div>
            </nav>
            <div className="loadSaveButtons">
              <UserListSaveDialog className={"actions"} products={selectedProducts} disabled={selectedProducts.length < 1} />
              <UserListLoadDialog className={"actions"} onLoad={this.onUserListLoaded.bind(this)} />
            </div>
            <span className="listHeader">
              <FormattedMessage id="search.selectedProducts" values={{ count: selectedProducts.length, max: maxSelectedProducts }} /> ({selectedProducts.length} <FormattedMessage id="common.of" /> {maxSelectedProducts} <FormattedMessage id="common.pieces" />)
            </span>
            <div className="clearButton">
              <Button variant="text" onClick={this.onResetClicked.bind(this)} disabled={clearDisabled} startIcon={<ClearIcon />}>
                <FormattedMessage id="navigation.clearSearch" />
              </Button>
            </div>
          </ResultList>
        )}

        <div className="divider" />

        <ResultList
          className="search"
          header={this.props.intl.formatMessage({ id: "search.searchResults" })}
          products={this.state.searchResult}
          selectedProducts={selectedProducts}
          onAddProduct={this.addToSelectedProducts.bind(this)}
          onRemoveProduct={this.removeFromSelectedProducts.bind(this)}
          onScrollToBottom={this.handleScrollToBottom.bind(this)}
          loading={this.state.searchLoading}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="app container">
        <div className="content">{this.isThirdPartyCookiesEnabled ? this.renderContent() : <ErrorView />}</div>

        <Drawer width="26%" className={"sidenav"} variant="permanent" PaperProps={{ elevation: 5 }} open>
          {this.renderSidenav()}
        </Drawer>

        <Snackbar open={!!this.state.snackbar} message={this.state.snackbar} autoHideDuration={3000} onRequestClose={() => this.setState({ snackbar: "" })} />
      </div>
    );
  }
}

export default injectIntl(App);
